import { Injectable } from "@angular/core";
import { OAuthService } from "angular-oauth2-oidc";
import { from, Observable, of } from "rxjs";
import { AccountService } from "./account.service";
import { RoleTypes } from "../models";

@Injectable()
export class AuthBaseService {
  constructor(protected oAuthService: OAuthService, protected accountSvc: AccountService) {}

  get isLoggedIn(): boolean {
    return this.accountSvc.isLoggedIn;
  }

  logout(noRedirectDuringLogout = false) {
    this.oAuthService.logOut(noRedirectDuringLogout);
    this.accountSvc.refreshUser(null);
    this.postLogoutActions();
  }

  login() {
    this.oAuthService.initImplicitFlow("");
  }

  refreshToken(params?: object): Observable<null> {
    if (!this.isLoggedIn) return of(null);
    return from(
      this.oAuthService.silentRefresh(params).then((r) => {
        this.accountSvc.refreshUser(this.accountSvc.user); // todo: check if it's needed
        return null;
      })
    );
  }

  isUserInRole(role: string): boolean {
    return this.accountSvc.isLoggedIn && this.accountSvc.user?.role === role;
  }

  isUserInRoles(roles: string[]): boolean {
    const userRole = this.accountSvc.user?.role;

    return this.accountSvc.isLoggedIn && !!userRole && roles.includes(userRole) && userRole !== RoleTypes.Sales;
  }

  /**
   * @deprecated Use `requiredMinimumRole` instead
   * // FIXME: Typo in method name
   */
  public requredMinimumRole(role: RoleTypes): boolean {
    return this.requiredMinimumRole(role);
  }

  requiredMinimumRole(role: RoleTypes): boolean {
    switch (role) {
      case RoleTypes.PartnerAdmin:
        return this.isUserInRoles([RoleTypes.Admin, RoleTypes.PartnerAdmin]);
      case RoleTypes.Manager:
        return this.isUserInRoles([RoleTypes.Admin, RoleTypes.PartnerAdmin, RoleTypes.Manager]);
      case RoleTypes.LocationManager:
        return this.isUserInRoles([RoleTypes.Admin, RoleTypes.PartnerAdmin, RoleTypes.Manager, RoleTypes.LocationManager]);
      default:
        return this.isUserInRole(role);
    }
  }

  protected postLogoutActions(): void {}
}
